import { theme } from '@nobia/zeus-components/lib/styled'

export default {
  body: {
    bgColor: '#F2E9DB',
    color: '#31261D',
    padding: '16px',
    tabletWidth: '680px',
    desktopWidth: '1001px',
  },
  section: {
    bgColor: '#E4D5C4',
    color: '#31261D',
    fontSize: '26px',
    fontWeight: '500',
  },
  header: {
    maxWidth: '985px',
    margin: '30px 70px 0 70px',
  },
  card: {
    border: {
      selected: '#31261D',
      default: '#E4D5C4',
    },
  },
  banner: {
    color: '#FBF9F6',
    bgColor: '#31261d',
  },
  tooltip: {
    color: '#FBF9F6',
    bgColor: '#31261d',
  },
  email: {
    error: {
      color: '#872E2E',
    },
    bgColor: '#F2E9DB',
    label: {
      fontSize: '14px',
    },
    input: {
      bgColor: '#fbf9f6',
      border: '1px solid #C3B5A7',
    },
    wrapper: {
      minWidth: '400px',
    },
    padding: '30px',
  },
  font: {
    headings: {
      fontFamily: theme('typography.headline.fontFamily'),
      fontWeight: '400',
      title: {
        fontSizeSm: '30px',
        lineHeightSm: '38px',
        fontSizeLg: '56px',
        lineHeightLg: '56px',
      },
    },
    preamble: {
      fontFamily: theme('typography.preamble.fontFamily'),
    },
    paragraph: {
      fontFamily: theme('typography.paragraph.fontFamily'),
    },
  },
  button: {
    fontWeight: '700',
    padding: '15px',
  },
  costSummary: {
    totalCost: {
      fontSize: '18px',
    },
    link: {
      fontSize: '13px',
    },
  },
  badaPromo: {
    image: {
      maxWidth: '460px',
    },
    wrapper: {
      padding: '80px 96px 30px',
    },
  },
  summary: {
    paddingRight: '10px',
    mobile: {
      paddingRight: '0px',
    },
  },
  input: {
    select: {
      bgColor: '#fbf9f6',
    },
    borderColor: '#C3B5A7',
  },
  colors: {
    primary: '#31261D',
    toneA: '#FAF5F2',
    button: '#C9682D',
  },
}
